import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useFormikContext } from 'formik';

import formatCurrency from 'components/utils/formatCurrency';
import planTotal from '../../utils/planTotal';

function Total({ plan }) {
  const [total, setTotal] = useState(0);

  const { mark, title: abbr } = plan.attributes.currency;

  const {
    values: {
      membersCovered,
      billingType,
    },
    touched,
    setFieldValue,
  } = useFormikContext();

  const isFree = plan?.attributes?.is_free || false;

  useEffect(() => {
    const newTotal = planTotal({
      plan,
      membersCovered,
      billingType,
    });
    setFieldValue('total', newTotal);
    setTotal(newTotal);
  }, [
    membersCovered,
    billingType,
    touched.membersCovered,
    touched.billingType,
  ]);

  return (
    <>
      {isFree && (
        <div className="fs-3 d-flex justify-content-between">
          <div>Premium:</div>
          <div>Free</div>
        </div>
      )}

      {!isFree && (
        <>
          <div className="mt-2 fs-3">Premium:</div>
          <div className="d-flex justify-content-end">
            <span className="me-1 fs-3">
              {mark}
              {formatCurrency(total, '')}
            </span>
            <span className="fw-light align-self-end mb-1">{abbr}</span>
          </div>
        </>
      )}
    </>
  );
}

Total.propTypes = {
  plan: PropTypes.object.isRequired,
};

export default Total;
